module.exports = __webpack_public_path__ + "static/media/blog_list4.68afa117.jpg";